import "./BurgerMunch.72d14e9a.js";
import "./BurgerMunch.8ee970a6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3421"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3421"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
function $c0585f8522820b4f$export$99056d8b093290da(phone) {
    return /^[+0-9 ()-]+$/.test(phone) && /^\d{9,15}$/.test(phone.replace(/\D/g, ""));
}



var $aStCm = parcelRequire("aStCm");

var $2pb0H = parcelRequire("2pb0H");

var $amjSx = parcelRequire("amjSx");
await (0, $2pb0H.initSite)();
$8a33d9c4ca362ed9$var$populateBranchSelect();
function $8a33d9c4ca362ed9$var$populateBranchSelect() {
    const select = document.getElementById("branch");
    if (!select) return;
    const placeholder = select.querySelector('option[value=""]')?.textContent || "\u05D1\u05D7\u05E8\u05D5 \u05E1\u05E0\u05D9\u05E3";
    select.innerHTML = `<option value="" disabled selected>${placeholder}</option>`;
    (0, $amjSx.getBranchList)().forEach((branch)=>{
        const name = branch.branch?.trim();
        if (!name) return;
        const option = document.createElement("option");
        option.value = name;
        option.textContent = name;
        select.appendChild(option);
    });
}
const $8a33d9c4ca362ed9$var$form = document.getElementById("contactForm");
const $8a33d9c4ca362ed9$var$errorEl = document.getElementById("form-error");
const $8a33d9c4ca362ed9$var$successEl = document.getElementById("form-success");
const $8a33d9c4ca362ed9$var$submitBtn = document.getElementById("submit-btn");
$8a33d9c4ca362ed9$var$form?.addEventListener("submit", async (event)=>{
    event.preventDefault();
    $8a33d9c4ca362ed9$var$hideMessages();
    const name = document.getElementById("name").value.trim();
    const email = document.getElementById("email").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const content = document.getElementById("content").value.trim();
    const branchSelect = document.getElementById("branch");
    const branch = branchSelect.value;
    if (!name || !email || !phone || !branch || !content) {
        $8a33d9c4ca362ed9$var$showError("\u05E0\u05D0 \u05DC\u05DE\u05DC\u05D0 \u05D0\u05EA \u05DB\u05DC \u05D4\u05E9\u05D3\u05D5\u05EA.");
        return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        $8a33d9c4ca362ed9$var$showError("\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D0\u05D9\u05E0\u05D4 \u05EA\u05E7\u05D9\u05E0\u05D4.");
        return;
    }
    if (!(0, $c0585f8522820b4f$export$99056d8b093290da)(phone)) {
        $8a33d9c4ca362ed9$var$showError("\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05EA\u05E7\u05D9\u05DF.");
        return;
    }
    $8a33d9c4ca362ed9$var$submitBtn.disabled = true;
    $8a33d9c4ca362ed9$var$submitBtn.textContent = "\u05E9\u05D5\u05DC\u05D7...";
    try {
        await (0, $aStCm.sessionRequest)("./api/contact.php", {
            name: name,
            email: email,
            phone: phone,
            branch: branch,
            content: content
        });
        $8a33d9c4ca362ed9$var$form.reset();
        $8a33d9c4ca362ed9$var$showSuccess("\u05D4\u05D4\u05D5\u05D3\u05E2\u05D4 \u05E0\u05E9\u05DC\u05D7\u05D4. \u05E0\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DB\u05DD \u05D1\u05D4\u05E7\u05D3\u05DD.");
    } catch  {
        $8a33d9c4ca362ed9$var$showError("\u05E9\u05DC\u05D9\u05D7\u05EA \u05D4\u05D4\u05D5\u05D3\u05E2\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4. \u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1 \u05D0\u05D5 \u05D4\u05EA\u05E7\u05E9\u05E8\u05D5 *2395.");
    } finally{
        $8a33d9c4ca362ed9$var$submitBtn.disabled = false;
        $8a33d9c4ca362ed9$var$submitBtn.textContent = "\u05E9\u05DC\u05D9\u05D7\u05D4";
    }
});
function $8a33d9c4ca362ed9$var$showError(message) {
    $8a33d9c4ca362ed9$var$errorEl.textContent = message;
    $8a33d9c4ca362ed9$var$errorEl.classList.add("is-visible");
}
function $8a33d9c4ca362ed9$var$showSuccess(message) {
    $8a33d9c4ca362ed9$var$successEl.textContent = message;
    $8a33d9c4ca362ed9$var$successEl.classList.add("is-visible");
}
function $8a33d9c4ca362ed9$var$hideMessages() {
    $8a33d9c4ca362ed9$var$errorEl.classList.remove("is-visible");
    $8a33d9c4ca362ed9$var$successEl.classList.remove("is-visible");
}


//# sourceMappingURL=contact.db7eecc1.js.map
